'use strict'

let endStageReport_fields=require('../../progress/labels/norwegian_endStage.js').norwegian_endStage;

export let norwegian={
  log: {
    eventLog: "Hendelseslogg",
    logDescription : "Hvem gjorde hva, når? Hendelsesloggen viser alle hendelser som har vært gjennom aktivitetens historie. Du kan filtrere innholdet i 'Hendelse'-kolonnen ved å legge inn nøkkelord å filtrere på.",
    eventFilter : "Legg inn hendelsesfilter",
    applyFilter : "Bruk filter",
    filterExamples : "F.eks.: Add, Risk, Issue, Person, Role",
    filteredOn: "Hendelseskolonnen er filtrert på '",
    date: "Dato",
    event: "Hendelse",
    details: "Detaljer",
    performedBy: "Utført av"
  },
  projectChanged: {
    types: {
      updatedProjectBackground: "Hvorfor ble prosjektet startet", //Reuse label from add project ?
      updatedProjectTiming: "Hvorfor nå?", //Reuse label from add project ?
      updatedProjectBigPicture: "Det større bildet", //Reuse label from add project ?
      changedProjectName: "navn",
      changedProjectIdentifier: "identifikator",
      changedProjectLocation: "sted",
      changedProjectDepartment: "avdeling",
      changedProjectPortfolio: "portefølje",
      changedProjectCategory: "kategori",
      changedProjectType: "prosjektype",

      changedProgrammeName: "navn",
      changedProgrammeIdentifier: "identikator",
      changedProgrammePortfolio: "portefølje",
      changedProgrammeLocation: "sted",
      changedProgrammeDepartment: "avdeling",
      updatedProgrammeBackground: "Begrunnelse og sammenheng",
      updatedProgrammeTiming: "Hvorfor nå?",
      updatedProgrammeSuccessFactors: "Suksessfaktorer",

      updatedProjectCurrency: "Valuta",

      changedProductName: "navn",
      changedProductIdentifier: "identifikator",
      changedProductPortfolio: "portefølje",
      changedProductLocation: "sted",
      changedProductDepartment: "avdeling",
      updatedProductDefinitionDescription: "beskrivelse",
      updatedProductDefinitionBackground: "bakgrunn",
      updatedProductDefinitionVision: "visjon",

      changedReleasePortfolio: "portefølje",
      changedReleaseIdentifier: "identifikator",

      unknownType: "(ukjent)"
    },
    changed: "Endret",
    to: "til",
    previous: "tidligere verdi"
  },
  report: {
    highlight: {
      title : "Statusrapport",
      endStageReport: "Etapperapport",
      endProjectReport: "Sluttrapport",
      projectDeliverables: "Leveranser fra prosjektet",
      summary: "Oppsummering",
      benefits: "Gevinster",
      time: "Tid",
      cost: "Kostnad",
      quality : "Kvalitet",
      scope: "Omfang",
      risk: "Risiko",
      currentPeriod : "Denne perioden",
      nextPeriod: "Neste periode",
      aspect: "Aspekt",
      status: "Status",
      description: "Beskrivelse",
      from: "fra",
      issues: "Saker",
      draftSaved: "Utlast lagret",
      preview: "Forhåndsvisning",
      teamPerformance: "Teamets prestasjoner",
      lessonsDescription: "Erfaringer",
      undefinedDate: "<ikke definert>",
      deliveryStatus: endStageReport_fields.Overview.fields.performedAchivements.title,
      start: "Start",
      end: "Slutt",
      managedBy: "Ledet av",
      listLimitedTo: "I denne rapporten, er listen over begrenset til",
      top5Risks: "top 5 riski",
      top5Issues: "top 5 saker"
    },
    issue: {
      title : "Saksrapport",
      exceptionTitle: "Unntaksrapport",
      impact: "Konsekvens",
      severity: "Alvorlighet",
      type: "Sakstype",
      typeValues: {
        change:"Endringsanmodning",
        specification: "Avvik fra spesifikasjon",
        problem: "Problem / utfordring"
      },
      severityValues: [ "Udefinert", "Ubetydelig", "Liten", "Moderat", "Betydelig", "Alvorlig"],
      priority: "Prioritet",
      priorityValues:["Undefined","Veldig lav","Lav","Middels","Høy","Veldig høy"],
      options:"Alternativer",
      recommendation:"Anbefaling",
      lessonSummary: "Erfaringer",
      decision:"Beslutning",
      decidedBy: "Beslutningen er fattet av",
      status:"Status",
      closed:"Lukket",
      active:"Aktiv",
      previewGenerated: "Forhåndsvisning generert"
    }
  }
};



// WEBPACK FOOTER //
// ./views/log/labels/norwegian.js